import { entityGenderList } from '../constants'

export const getEntityGender = (gender) => entityGenderList.find(entity => entity.value === gender)
